import '@/utils/user.env.js';
import Vue from 'vue';
import mui from 'mui';
import App from './App.vue';
import router from './router';
import store from '../../store/index';
import JsDynamicLoader from '@midea/js-dynamic-loader';
import MdesignPlus from 'mdesign-plus';
import 'mdesign-plus/lib/theme-chalk/index.css';
// import ElementUI from 'element-ui';
// import MDesign from 'mdesign';
// import 'element-ui/lib/theme-chalk/index.css';
// import 'mdesign/lib/style/index.css';


import '../../utils/directive/highlight';
import '../../utils/directive/display';
// import { checkLogin } from '../../utils/index';
// import '@midea/mui/dist/styles/mui.css';
import '@/styles/mui.css';
import '../../styles/base.less';
import userConfig from '@/config/user.env';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import globalMixin from '@/mixin/globalMixin.js';

import setTable from '@/components/table/setTable'; 
import getLanguage from '@/utils/loadLanguage.js';
Vue.component('set-table', setTable);
// Vue.use(ElementUI);
Vue.use(MdesignPlus);
Vue.config.productionTip = false;
Vue.component('staff-selector', () => JsDynamicLoader(userConfig.staffSelector.url));
Vue.component('m-ueditor', () => JsDynamicLoader(userConfig.uEditor.url));
Vue.use(VueAwesomeSwiper);
try {
} catch (err) {
  console.log(err);
}
Vue.mixin(globalMixin);
// checkLogin(router); // 改成用接口判断是否登录
(async () => {
  store.dispatch('initSystem').then(res => {
    if (res) {
      store.dispatch('UPDATE_LANG').then(i18n => {
        Vue.use(mui, {
          i18n: (path, options) => {
            const value = i18n.t(path, options);
            if (value) return value;
            return '';
          },
        });
        window.vue = Vue;
        getLanguage(i18n).finally(() => {
          new Vue({
            router,
            store,
            i18n,
            render: h => h(App),
          }).$mount('#app');
        });
      });
    }
  }, err => {
    mui.Message.info({
      content: '系统初始化出错：' + err,
      duration: 0,
      closable: true,
    });
  });
})();
